const calculateRate = (baseCurrency, targetCurrency, autoCurrencyRates) => {
  if (baseCurrency === 'USD') {
    const actualRate = autoCurrencyRates[targetCurrency];
    return actualRate;
  }

  const rateBasedOnUsd = 1 / autoCurrencyRates[baseCurrency];
  const actualRate = rateBasedOnUsd * autoCurrencyRates[targetCurrency];

  return actualRate;
};

export { calculateRate };
